import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';

import useAuth from '../../hooks/useAuth';
import axios from '../../utils/axios';
import { PATH_MAIN } from '../../routes/paths';
import TermsCheckboxes from '../../components/TermsCheckboxes';

export default function AcceptTermsPage() {
  const navigate = useNavigate();
  const { acceptTerms } = useAuth();

  const [checked, setChecked] = useState({
    termini: false,
    privacy: false,
    consenso: false,
    ugoTermini: false,
    ugoPrivacy: false,
    ugoConsenso: false,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const allChecked = Object.values(checked).every(Boolean);

  const handleChange = (name) => (event) => {
    setChecked((prev) => ({ ...prev, [name]: event.target.checked }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!allChecked) return;
    setLoading(true);
    setError(null);
    try {
      await axios.post('/profile/accept-terms', {});
      acceptTerms();
      navigate(PATH_MAIN.main.dashboard, { replace: true });
    } catch (err) {
      setError('Si è verificato un errore. Riprova.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="div" maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: 'white',
          borderRadius: 3,
          p: 4,
          boxShadow: '0px 4px 24px rgba(0,0,0,0.08)',
        }}
      >
        <Typography
          component="h1"
          variant="h5"
          sx={{ color: '#004990', fontWeight: 'bold', mb: 1 }}
        >
          Accettazione termini
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: 'center' }}>
          Per continuare ad utilizzare CareTogether è necessario accettare i seguenti termini e condizioni.
        </Typography>

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <TermsCheckboxes values={checked} onChange={handleChange} />

          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}

          <Button
            type="submit"
            variant="contained"
            fullWidth
            disabled={!allChecked || loading}
            sx={{ mt: 3, backgroundColor: '#2CA4DE' }}
          >
            {loading ? 'Salvataggio...' : 'Conferma e continua'}
          </Button>
        </form>
      </Box>
    </Container>
  );
}

